import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b896afe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = { class: "header_box" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("批量确认同步")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("恢复")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("作废")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确认同步")

import { reactive, defineAsyncComponent } from 'vue'

import MainLayout from '@/components/layout/mainLayout/mainLayout.vue'
import TableLayout from '@/components/layout/tableLayout/tableLayout.vue'

import { useReflectiveInjector } from '@tanbo/vue-di-plugin';
import { ConstPagination } from '@/common/const';
import { MatsManageResponseData, OfficePlusStatusLabelMap, OfficePlusAuditState, OfficePlusAuditStateMap, OfficePlusStatus, OfficeplusService } from './officeplus.service';
import { formatDate } from '@shared/utils/base';
import { ElMessage } from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ContentManageDialog = defineAsyncComponent(() => import('./_components/contentManageDialog/contentManageDialog.vue'))

const categoryMap: any = {
  10000: 'PPT模板',
  20000: 'WORD',
  30000: 'EXCEL',
  40000: 'PPT单页',
  50000: 'PPT主题'
}
const injector = useReflectiveInjector([OfficeplusService])
const service = injector.get(OfficeplusService)

const searchHandle = reactive({
  type: '',
  l1_category_id: null,
  status: null,
  officeplus_audit_state: null,
  loading: false,
  title: '',
  templateId: null,
  search: () => {
    searchHandle.loading = true
    initData()
  }
})
const selectable = (row: any) => row.status === OfficePlusStatus.PENDING_CONFIRMATION
const tableHandle = reactive({
  mats: [],
  loading: false,
  multipleSelection: [],
  handleSelectionChange: (val: any) => {
    tableHandle.multipleSelection = val
  },
  clickDetail: (id: number) => {
    contentManageDialogHandle.visible = true
    contentManageDialogHandle.id = id
  },
  clickConfirm: (ids?: number[]) => {
    if (!ids) {
      ids = tableHandle.multipleSelection.filter(item => item.status === OfficePlusStatus.PENDING_CONFIRMATION).map((item: any) => item.id)
    }
    if (!ids.length && tableHandle.multipleSelection.length) {
      ElMessage.error('只能选择待确认的状态的模板')
      return 
    }
    if (!ids.length) {
      ElMessage.error('请选择至少一个模板')
      return 
    }
    service.sysncStatus({ ids: ids }).then(() => {
      initData()
    })
  },
  clickDisable: (id) => {
    service.disableStatus({ ids: [id] }).then(() => {
      initData()
    })
  },
  clickUndisable: (id) => {
    service.unDisableStatus({ ids: [id] }).then(() => {
      initData()
    })
  },
})

const contentManageDialogHandle = reactive({
  visible: false,
  id: null,
  clickContentManageDialogClose() {
    contentManageDialogHandle.visible = false
  },
  clickContentManageDialogModify() {
    contentManageDialogHandle.visible = false
    initData()
  }
})

const paginationHandle = reactive({
  total: 0,
  page: 1,
  size: ConstPagination.defaultPageSize,
  handleSizeChange: (page: number) => {
    paginationHandle.size = page
    initData()
  },
  handleCurrentChange: (page: number) => {
    paginationHandle.page = page
    initData()
  }
})
initData()
function initData() {
  tableHandle.loading = true

  const params: any = { page: paginationHandle.page, size: paginationHandle.size }
  if (searchHandle.templateId) {
    params.id = Number(searchHandle.templateId)
  }
  if (searchHandle.title) {
    params.title = searchHandle.title
  }
  if (searchHandle.status >= 0) {
    params.status = Number(searchHandle.status)
  }
  if (searchHandle.l1_category_id >= 0) {
    params.l1_category_id = Number(searchHandle.l1_category_id)
  }
  if (searchHandle.officeplus_audit_state >= 0) {
    params.officeplus_audit_state = Number(searchHandle.officeplus_audit_state)
  }

  service.getList(params).then((data: MatsManageResponseData) => {
    tableHandle.mats = data.list
    paginationHandle.total = data.total
  }).finally(() => {
    searchHandle.loading = false
    tableHandle.loading = false
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(MainLayout, null, {
    default: _withCtx(() => [
      _createVNode(TableLayout, null, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_space, { class: "search_box" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(searchHandle).l1_category_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchHandle).l1_category_id) = $event)),
                  class: "select",
                  placeholder: "请选择分类"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "全部",
                      value: -1
                    }),
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(categoryMap, (item, key) => {
                      return _createVNode(_component_el_option, {
                        key: key,
                        label: item,
                        value: key
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_select, {
                  modelValue: _unref(searchHandle).status,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchHandle).status) = $event)),
                  class: "select",
                  placeholder: "请选择状态"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "全部",
                      value: -1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(OfficePlusStatusLabelMap), (item, key) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: key,
                        label: item,
                        value: key
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_select, {
                  modelValue: _unref(searchHandle).officeplus_audit_state,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchHandle).officeplus_audit_state) = $event)),
                  class: "select",
                  placeholder: "请选择审核状态"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "全部",
                      value: -1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(OfficePlusAuditStateMap), (item, key) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: key,
                        label: item,
                        value: key
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_input, {
                  modelValue: _unref(searchHandle).title,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchHandle).title) = $event)),
                  class: "input",
                  placeholder: "请输入模板id或标题"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  loading: _unref(searchHandle).loading,
                  onClick: _unref(searchHandle).search
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_popconfirm, {
              title: "是否确认该操作?",
              onConfirm: _cache[4] || (_cache[4] = ($event: any) => (_unref(tableHandle).clickConfirm()))
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  loading: _unref(tableHandle).loading
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ])
        ]),
        main: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            height: "100%",
            border: "",
            data: _unref(tableHandle).mats,
            class: "table_box",
            onSelectionChange: _unref(tableHandle).handleSelectionChange,
            "row-key": "id"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "selection",
                selectable: selectable,
                width: "55"
              }),
              _createVNode(_component_el_table_column, {
                width: "100",
                prop: "mat_id",
                label: "模板ID"
              }),
              _createVNode(_component_el_table_column, {
                width: "100",
                prop: "category_id",
                label: "模板分类"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(categoryMap[scope.row.l1_category_id]), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                "min-width": "400",
                prop: "title",
                label: "模板标题"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", null, _toDisplayString(scope.row.title), 1),
                  _createVNode(_component_el_space, { wrap: "" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.tag_names, (tag) => {
                        return (_openBlock(), _createBlock(_component_el_tag, {
                          size: "small",
                          key: tag
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tag), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                width: "200",
                prop: "keywords",
                label: "关键词"
              }),
              _createVNode(_component_el_table_column, {
                width: "60",
                prop: "price",
                label: "价格"
              }),
              _createVNode(_component_el_table_column, {
                width: "160",
                prop: "upload_time",
                label: "更新时间"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_unref(formatDate)(new Date(scope.row.update_time), 'yyyy-MM-dd hh:mm:ss')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "模板状态",
                width: "100",
                prop: "status"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString(_unref(OfficePlusStatusLabelMap)[scope.row.status as OfficePlusStatus]), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "审核状态",
                width: "100",
                prop: "officeplus_audit_state"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString(_unref(OfficePlusAuditStateMap)[scope.row.officeplus_audit_state] || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "不通过原因",
                width: "130",
                prop: "officeplus_reject_reason"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString(scope.row.officeplus_reject_reason || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                width: "220",
                label: "操作",
                fixed: "right"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "primary",
                    onClick: ($event: any) => (_unref(tableHandle).clickDetail(scope.row.id))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  (scope.row.status === _unref(OfficePlusStatus).DISABLED || scope.row.officeplus_audit_state === _unref(OfficePlusAuditState).AUDIT_DISABLED)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        size: "small",
                        type: "success",
                        onClick: ($event: any) => (_unref(tableHandle).clickUndisable(scope.row.id))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        size: "small",
                        type: "danger",
                        onClick: ($event: any) => (_unref(tableHandle).clickDisable(scope.row.id))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 2
                      }, 1032, ["onClick"])),
                  (scope.row.status === _unref(OfficePlusStatus).PENDING_CONFIRMATION)
                    ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                        key: 2,
                        title: "是否确认该操作?",
                        onConfirm: ($event: any) => (_unref(tableHandle).clickConfirm([scope.row.id]))
                      }, {
                        reference: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            size: "small",
                            type: "primary"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onConfirm"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "onSelectionChange"])), [
            [_directive_loading, _unref(tableHandle).loading]
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_el_pagination, {
            align: "right",
            "current-page": _unref(paginationHandle).page,
            "page-size": _unref(paginationHandle).size,
            total: _unref(paginationHandle).total,
            onSizeChange: _unref(paginationHandle).handleSizeChange,
            onCurrentChange: _unref(paginationHandle).handleCurrentChange
          }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
        ]),
        _: 1
      }),
      (_unref(contentManageDialogHandle).visible)
        ? (_openBlock(), _createBlock(_unref(ContentManageDialog), {
            key: 0,
            id: _unref(contentManageDialogHandle).id,
            modelValue: _unref(contentManageDialogHandle).visible,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(contentManageDialogHandle).visible) = $event)),
            onClickContentManageDialogClose: _unref(contentManageDialogHandle).clickContentManageDialogClose,
            onClickContentManageDialogModify: _unref(contentManageDialogHandle).clickContentManageDialogModify
          }, null, 8, ["id", "modelValue", "onClickContentManageDialogClose", "onClickContentManageDialogModify"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})